export const CONFIG = {
  collectionName: 'realtime-events',
  subCollection: 'events',
};
